import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuthentication } from "../hooks/useAuthentication";
import { useLinks } from "../hooks/useLinks";
import { redirectPathKey } from "./AuthenticatedGuard";

export type UnauthenticatedGuardProps = {
  children?: ReactNode;
};

export const UnauthenticatedGuard = (props: UnauthenticatedGuardProps) => {
  const { children } = props;
  const { isAuthenticated } = useAuthentication();
  const links = useLinks();
  const redirectPath = links.home();

  if (isAuthenticated) {
    sessionStorage.removeItem(redirectPathKey);
    return <Navigate to={redirectPath} replace />;
  }

  return <>{children}</>;
};
